import axios from "axios"

const api = axios.create({
    // baseURL: 'http://localhost:3002'
    baseURL: 'https://fgf7khw7r3.execute-api.sa-east-1.amazonaws.com/production'
})
export default api